import cs from 'classnames';
import { Pagination as AntdPagination } from 'antd';
import CustomIcon from '@components/shared/CustomIcon';
import s from './Pagination.module.less';

type Props = {
  onChange: (newPage: number) => void;
  testId?: string;
  currentPage: number | undefined;
  total: number | undefined;
  pageSize: number | undefined;
  displayEvenIfEmpty?: boolean;
  showTotal?: boolean;
};

// to match the ant-d :/
/* eslint-disable jsx-a11y/anchor-is-valid */
const Pagination = ({
  onChange,
  testId = 'pagination',
  currentPage = 1,
  total = 0,
  pageSize = 0,
  displayEvenIfEmpty = false,
  showTotal = false,
}: Props) => {
  const showTotalFn = showTotal
    ? (totalNum: number, range: [number, number]) => `${range[0]}-${range[1]} of ${totalNum} items`
    : undefined;
  return total > pageSize || displayEvenIfEmpty ? (
    <>
      <AntdPagination
        className={s.pagination}
        current={currentPage}
        total={total}
        pageSize={pageSize}
        data-testid={testId}
        showTotal={showTotalFn}
        itemRender={(page, type, original) => {
          if (type === 'next') {
            return (
              <a className={cs('ant-pagination-item-link', s.nextButton)}>
                <CustomIcon type="chevron-right-slate" />
              </a>
            );
          }

          if (type === 'prev') {
            return (
              <a className={cs('ant-pagination-item-link', s.prevButton)}>
                <CustomIcon type="chevron-left-slate" />
              </a>
            );
          }

          return original;
        }}
        onChange={onChange}
      />
      <AntdPagination
        className={cs(s.pagination, s.mobile)}
        current={currentPage}
        total={total}
        pageSize={pageSize}
        /* eslint-disable-next-line react/jsx-no-literals */
        data-testid={`${testId}-mobile`}
        simple
        itemRender={(page, type, original) => {
          if (type === 'next') {
            return (
              <a className={cs('ant-pagination-item-link', s.nextButton)} title="Next Page">
                <CustomIcon type="chevron-right-slate" />
              </a>
            );
          }

          if (type === 'prev') {
            return (
              <a className={cs('ant-pagination-item-link', s.prevButton)} title="Previous Page">
                <CustomIcon type="chevron-left-slate" />
              </a>
            );
          }

          return original;
        }}
        onChange={onChange}
      />
    </>
  ) : null;
};

export default Pagination;
